import ApiClient from '../../_config/client';

export const getLocalization = () => ApiClient.get("/localization");